import { render, staticRenderFns } from "./ip-voice.vue?vue&type=template&id=34baa11f&"
import script from "./ip-voice.vue?vue&type=script&lang=js&"
export * from "./ip-voice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports